import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/products'
import Component from 'components/Products/Select'

export default createListModalContainer({ actions })(Component)
